import {
  Document,
  Image,
  Page,
  PDFViewer,
  Text,
  View,
} from '@react-pdf/renderer';
import QRCode from 'qrcode';
import { useHistory } from 'react-router-dom';
import { usePDFData } from '../../hooks/usePDFData';
import { Button } from '..';
import logo from '../../assets/logo.png';
import check from '../../assets/icons/check.png';
import uncheck from '../../assets/icons/not-check.png';
import brokenFile from '../../assets/broken-file.svg';

import pdfStyles from './pdf-styles';
import * as S from './styles';
import { bases } from '../../pages/RegisterOS/data';

const OSPDF = () => {
  const history = useHistory();
  const { pdfData } = usePDFData();
  const canvas = document.createElement('canvas');
  let osNumber = pdfData?.os_number ? pdfData?.os_number : undefined;
  let registerByName = pdfData?.register_by_name
    ? pdfData?.register_by_name
    : undefined;

  if (osNumber === undefined) {
    osNumber = '-1';
  }

  if (registerByName === undefined) {
    registerByName = 'indefinido';
  }

  QRCode.toCanvas(
    canvas,
    `${process.env.REACT_APP_API_URL}/pre-os/${osNumber}?register_by=${registerByName}`,
  );
  const qrcde = canvas.toDataURL();

  if (!pdfData?.product) {
    return (
      <S.ContainerError>
        <img src={brokenFile} alt="Imagem de um papel rasgado ao meio" />
        <strong>Ooops...</strong>
        <p>
          Não foi possível visualizar seu PDF agora. Tente voltar e gerar
          novamente. Se o problema persistir, contate o administrador.
        </p>
        <Button
          text="Voltar"
          outlined
          containerStyle={{ alignSelf: 'center', marginTop: '0.8rem' }}
          onClick={() => history.goBack()}
        />
      </S.ContainerError>
    );
  }

  return (
    <S.Container>
      <div style={{ height: '100%' }}>
        <Button
          text="Voltar"
          outlined
          containerStyle={{
            position: 'absolute',
            top: 20,
            left: 10,
            zIndex: 1000,
            borderColor: '#fff',
            color: '#fff',
          }}
          onClick={() => history.goBack()}
        />
      </div>
      <div>
        <PDFViewer style={pdfStyles.viewer}>
          <Document>
            <Page size="A4" wrap style={pdfStyles.page}>
              <View style={pdfStyles.header}>
                <Image src={logo} style={pdfStyles.logo} />

                <View style={pdfStyles.osInfoHeader}>
                  <View style={pdfStyles.osInfoContainer}>
                    <Text style={pdfStyles.osInfoLabel}>Número da O.S.:</Text>
                    <Text>{osNumber}</Text>
                  </View>
                  <View style={pdfStyles.osInfoContainer}>
                    <Text style={pdfStyles.osInfoLabel}>Aberto em:</Text>
                    <Text>
                      {new Date(pdfData.created_at).toLocaleString('pt-BR')}
                    </Text>
                  </View>
                </View>

                <Image src={qrcde} style={pdfStyles.qrcode} />
              </View>

              <View style={pdfStyles.clientInfo}>
                <View style={pdfStyles.osInfoContainer}>
                  <Text style={pdfStyles.osInfoLabel}>Cliente:</Text>
                  <Text>{pdfData.customer_name}</Text>
                </View>
                <View style={pdfStyles.osInfoContainer}>
                  <Text style={pdfStyles.osInfoLabel}>Contato:</Text>
                  <Text>{pdfData.customer_contact || 'Não informado'}</Text>
                </View>
              </View>

              {/* Dados do atendimento */}
              <View style={pdfStyles.section}>
                <View style={pdfStyles.sectionTitleBackground}>
                  <Text style={pdfStyles.sectionTitle}>
                    Dados do atendimento
                  </Text>
                </View>

                <View style={pdfStyles.osInfoSection}>
                  <Text style={pdfStyles.osInfoSectionLabel}>Produto:</Text>
                  <Text>{pdfData.product.description}</Text>
                </View>
                <View style={pdfStyles.osInfoSection}>
                  <Text style={pdfStyles.osInfoSectionLabel}>Fabricante:</Text>
                  <Text>{pdfData.manufacturer.name}</Text>
                </View>
                <View style={pdfStyles.osInfoSection}>
                  <Text style={pdfStyles.osInfoSectionLabel}>Vendedor:</Text>
                  <Text>{pdfData.salesman}</Text>
                </View>
                <View style={pdfStyles.osInfoSection}>
                  <Text style={pdfStyles.osInfoSectionLabel}>
                    Oftalmologista:
                  </Text>
                  <Text>{pdfData.ophthalmologist}</Text>
                </View>
                <View style={pdfStyles.osInfoSection}>
                  <Text style={pdfStyles.osInfoSectionLabel}>
                    Cliente Certificado:
                  </Text>
                  <Text>{pdfData.customer_certified_name}</Text>
                </View>
                <View style={pdfStyles.osInfoGroupInputs}>
                  <View style={pdfStyles.osInfoSection}>
                    <Text style={pdfStyles.osInfoSectionLabel}>Previsão:</Text>
                    <Text>
                      {pdfData.prevision
                        ? new Date(pdfData.prevision).toLocaleDateString()
                        : ''}
                    </Text>
                  </View>
                  <View style={pdfStyles.osInfoSection}>
                    <Text style={pdfStyles.osInfoSectionLabel}>Status:</Text>
                    <Text>{pdfData.status}</Text>
                  </View>
                  <View style={pdfStyles.osInfoSection}>
                    <Text style={pdfStyles.osInfoSectionLabel}>Usuário:</Text>
                    <Text>{registerByName}</Text>
                  </View>
                </View>
              </View>

              {/* Prescrição */}
              <View style={pdfStyles.section}>
                <View style={pdfStyles.sectionTitleBackground}>
                  <Text style={pdfStyles.sectionTitle}>Prescrição</Text>
                </View>

                <View style={pdfStyles.tableHeader}>
                  <Text style={pdfStyles.thLeft}>OLHO</Text>
                  <Text style={pdfStyles.th}>ESF</Text>
                  <Text style={pdfStyles.th}>CIL</Text>
                  <Text style={pdfStyles.th}>EIXO</Text>
                  <Text style={pdfStyles.th}>ADD</Text>
                  <Text style={pdfStyles.th}>DNP</Text>
                  <Text style={pdfStyles.th}>ALTURA</Text>
                </View>
                <View style={pdfStyles.tableBody}>
                  <Text style={pdfStyles.tdLeft}>Direito</Text>
                  <Text style={pdfStyles.td}>{pdfData.esf_right_eye}</Text>
                  <Text style={pdfStyles.td}>{pdfData.cil_right_eye}</Text>
                  <Text style={pdfStyles.td}>
                    {Number(pdfData.eixo_right_eye)}
                  </Text>
                  <Text style={pdfStyles.td}>{pdfData.add_right_eye}</Text>
                  <Text style={pdfStyles.td}>{pdfData.dnp_right_eye}</Text>
                  <Text style={pdfStyles.td}>{pdfData.height_right_eye}</Text>
                </View>
                <View style={pdfStyles.tableBody}>
                  <Text style={pdfStyles.tdLeft}>Esquerdo</Text>
                  <Text style={pdfStyles.td}>{pdfData.esf_left_eye}</Text>
                  <Text style={pdfStyles.td}>{pdfData.cil_left_eye}</Text>
                  <Text style={pdfStyles.td}>
                    {Number(pdfData.eixo_left_eye)}
                  </Text>
                  <Text style={pdfStyles.td}>{pdfData.add_left_eye}</Text>
                  <Text style={pdfStyles.td}>{pdfData.dnp_left_eye}</Text>
                  <Text style={pdfStyles.td}>{pdfData.height_left_eye}</Text>
                </View>
              </View>

              {/* Medidas e Serviços */}
              <View style={pdfStyles.sectionGroup}>
                <View style={[pdfStyles.section, { width: '49%' }]}>
                  <View style={pdfStyles.sectionTitleBackground}>
                    <Text style={pdfStyles.sectionTitle}>Medidas</Text>
                  </View>

                  <View style={pdfStyles.osInfoSection}>
                    <Text style={pdfStyles.osInfoSectionLabel}>
                      Horizontal:
                    </Text>
                    <Text>{pdfData.horizontal}</Text>
                  </View>
                  <View style={pdfStyles.osInfoSection}>
                    <Text style={pdfStyles.osInfoSectionLabel}>Vertical:</Text>
                    <Text>{pdfData.vertical}</Text>
                  </View>
                  <View style={pdfStyles.osInfoSection}>
                    <Text style={pdfStyles.osInfoSectionLabel}>
                      Ponte (PO):
                    </Text>
                    <Text>{pdfData.po}</Text>
                  </View>
                  <View style={pdfStyles.osInfoSection}>
                    <Text style={pdfStyles.osInfoSectionLabel}>Diagonal:</Text>
                    <Text>{pdfData.diagonal}</Text>
                  </View>
                  <View style={pdfStyles.osInfoSection}>
                    <Text style={pdfStyles.osInfoSectionLabel}>Modelo:</Text>
                    <Text>{pdfData.model}</Text>
                  </View>
                  <View style={pdfStyles.osInfoSection}>
                    <Text style={pdfStyles.osInfoSectionLabel}>Armação:</Text>
                    <Text>{pdfData.frame}</Text>
                  </View>
                  <View style={pdfStyles.osInfoSection}>
                    <Text style={pdfStyles.osInfoSectionLabel}>
                      Referência:
                    </Text>
                    <Text>{pdfData.reference}</Text>
                  </View>
                </View>

                <View style={[pdfStyles.section, { width: '49%' }]}>
                  <View style={pdfStyles.sectionTitleBackground}>
                    <Text style={pdfStyles.sectionTitle}>Serviços</Text>
                  </View>

                  <View style={pdfStyles.osInfoSection}>
                    <Text style={pdfStyles.osInfoServiceLabel}>Montagem:</Text>
                    <Image
                      src={Number(pdfData.mounting) === 1 ? check : uncheck}
                      style={pdfStyles.icon}
                    />
                  </View>
                  <View style={pdfStyles.osInfoSection}>
                    <Text style={pdfStyles.osInfoServiceLabel}>
                      Antirrisco:
                    </Text>
                    <Image
                      src={Number(pdfData.antiscratch) === 1 ? check : uncheck}
                      style={pdfStyles.icon}
                    />
                  </View>
                  <View style={pdfStyles.osInfoSection}>
                    <Text style={pdfStyles.osInfoServiceLabel}>Coloração:</Text>
                    <Image
                      src={Number(pdfData.coloring) === 1 ? check : uncheck}
                      style={pdfStyles.icon}
                    />
                  </View>
                  <View style={pdfStyles.osInfoSection}>
                    <Text style={pdfStyles.osInfoSectionLabel}>
                      Tipo Coloração:
                    </Text>
                    <Text>{pdfData.coloring_type}</Text>
                  </View>
                  <View style={pdfStyles.osInfoSection}>
                    <Text style={pdfStyles.osInfoServiceLabel}>
                      Antirreflexo:
                    </Text>
                    <Image
                      src={
                        Number(pdfData.antireflection) === 1 ? check : uncheck
                      }
                      style={pdfStyles.icon}
                    />
                  </View>
                  <View style={pdfStyles.osInfoSection}>
                    <Text style={pdfStyles.osInfoSectionLabel}>
                      Tipo antirreflexo:
                    </Text>
                    <Text>{pdfData.antireflection_type}</Text>
                  </View>
                </View>
              </View>

              <View style={pdfStyles.sectionGroup}>
                <View style={[pdfStyles.section, { width: '49%' }]}>
                  <View style={pdfStyles.sectionTitleBackground}>
                    <Text style={pdfStyles.sectionTitle}>Observações</Text>
                  </View>

                  <Text>{pdfData.observations}</Text>
                </View>

                {pdfData.print_prisma > 0 && (
                  <View style={[pdfStyles.section, { width: '49%' }]}>
                    <View style={pdfStyles.sectionTitleBackground}>
                      <Text style={pdfStyles.sectionTitle}>Prisma</Text>
                    </View>

                    <View style={pdfStyles.sectionPrism}>
                      <Text style={pdfStyles.prismContainerTitle}>
                        Olho Direito
                      </Text>
                      <View style={pdfStyles.prismContainerEye}>
                        <View style={pdfStyles.prismContainerEyeInfo}>
                          <Text style={pdfStyles.osInfoSectionLabel}>
                            Quantidade:
                          </Text>
                          <Text>{pdfData.right_base_quantity || 'Nenhum'}</Text>
                        </View>
                        <View style={pdfStyles.prismContainerEyeInfo}>
                          <Text style={pdfStyles.osInfoSectionLabel}>
                            Base:
                          </Text>
                          <Text>
                            {bases.find(
                              base => base.value === Number(pdfData.right_base),
                            )?.label || 'Nenhum'}
                          </Text>
                        </View>
                      </View>
                    </View>
                    <View style={pdfStyles.sectionPrism}>
                      <Text style={pdfStyles.prismContainerTitle}>
                        Olho Esquerdo
                      </Text>
                      <View style={pdfStyles.prismContainerEye}>
                        <View style={pdfStyles.prismContainerEyeInfo}>
                          <Text style={pdfStyles.osInfoSectionLabel}>
                            Quantidade:
                          </Text>
                          <Text>{pdfData.left_base_quantity || 'Nenhum'}</Text>
                        </View>
                        <View style={pdfStyles.prismContainerEyeInfo}>
                          <Text style={pdfStyles.osInfoSectionLabel}>
                            Base:
                          </Text>
                          <Text>
                            {bases.find(
                              base => base.value === Number(pdfData.left_base),
                            )?.label || 'Nenhum'}
                          </Text>
                        </View>
                      </View>
                    </View>
                  </View>
                )}
              </View>
            </Page>
          </Document>
        </PDFViewer>
      </div>
    </S.Container>
  );
};

export default OSPDF;
